import AOS from "aos";
import "aos/dist/aos.css";
import React, { lazy, Suspense, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Notification } from "../../components/alerting-visitors/notification";
import SideBar from "../../components/sidebar/Sidebar";
import UserBase from "../../components/user/UserBase";
import {
  getAttorney,
  getBeneficiary,
  getCombinedData,
  getLiabilitiesValue,
  getNetworth,
  getNetworthForGraph,
  getOwnerByUserId,
  getToken,
  getUser,
  getExistAttorneyInvitationByUsername,
  getAllAcceptedAttorneysByUsername,
} from "../../services/user-service";
import { getRealEstates } from "../../services/RealEstate-service";
import { getVehicle } from "../../services/VehicleService";
import { getInternationalAsset } from "../../services/InternationalAssetService";
import {
  Switch,
  FormControlLabel,
  IconButton,
  Popover,
  Button,
  Typography,
} from "@mui/material";import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {motion} from "framer-motion";
import {
  differenceInMonths,
  differenceInYears,
  format,
  parseISO,
} from "date-fns";
import { useEffect } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import {
  Area,
  AreaChart,
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Sector,
  Brush,
} from "recharts";
import AlertPopup from "../../components/alerting-visitors/alertpopup";
import { formatAmount } from "../../components/Common";
import AttorneyDetail from "../AttorneyDetail";
import CreateOwner from "../CreateOwner";
import "./UserDashboard.css";
import Loading from "../../components/Loading";
import CreateTrust from "../trust-page/CreateTrust";
import {toast} from "react-toastify";

const GenerateWill = lazy(() => import("../my-estate/GenerateWill"));
const JointAccount = lazy(() => import("../JointAccount"));

const BeneficiarySignup = lazy(() => import("../BeneficiarySignup"));

export default function Userdashboard() {
    const navigate = useNavigate();
const user = getUser();
const userId = user?.commonId;
const userAccountType = user?.accountType;
const [showValues, setShowValues] = useState(true);
const [show] = useState(true);
const [token, setToken] = useState("");
const [activeAssetIndex, setActiveAssetIndex] = useState(null);
const [activeLiabilityIndex, setActiveLiabilityIndex] = useState(null);

  const [infoOpen, setInfoOpen] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  // get combined data in single list
  const [combinedData, setCombinedData] = useState(null);
  const getCombinedDataFromServer = () => {
    getCombinedData(userId)
      .then((res) => {
        setCombinedData(res);
        openPopup();
      })
      .catch((err) => {});
  };

  // check user has attorney or not
  const [attorneyStringType, setAttorneyStringType] = useState(false);
  const getAttorneyData = () => {
    let userId = getUser().id;
    let token = "Bearer " + getToken();
    getAttorney(token, userId)
      .then((res) => {
        if (typeof res === "string") {
          setAttorneyStringType(true);
        }
      })
      .catch((err) => {});
  };

  // check user has benificiary or not
  const [beneficiary, setBeneficiary] = useState(false);
  const getBenificiarydata = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        if (res.length > 0) {
          setBeneficiary(true);
        }
      })
      .catch((err) => {});
  };

  // check user has benificiary or not
  const [isOwner, setIsOwner] = useState(false);
  const getOwnerdata = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getOwnerByUserId(token, userId)
      .then((res) => {
        if (res.length > 0) {
          setIsOwner(true);
        }
      })
      .catch((err) => {});
  };

  const handleClick = (url) => {
    // Handle the click event here
    navigate("/user/my-estate/" + url);
  };

  const [addBeneficiary, setAddBeneficiary] = useState(false);

  const toggleBeneficiary = () => {
    setAddBeneficiary(!addBeneficiary);
  };

  const [addOwner, setAddOwner] = useState(false);

  const toggleAddOwner = () => {
    setAddOwner(!addOwner);
  };

  const [addTrust, setAddTrust] = useState(false);

  const toggleAddTrust = () => {
    setAddTrust(!addTrust);
  };

  // for joint account popup
  const [addJointPopup, setAddJointPopup] = useState(false);
  const toggleJointAccount = () => {
    setAddJointPopup(!addJointPopup);
  };

  const handleBack = () => {
    setAddBeneficiary(false);
    setAddJointPopup(false);
    setAttorneyPopup(false);
    setAddTrust(false);
    setAddOwner(false);
  };
  AOS.init();

  // popup component
  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const [attorneyPopup, setAttorneyPopup] = useState(false);

  const toggleAttorney = () => {
    setAttorneyPopup(!attorneyPopup);
  };

  useEffect(() => {
    getAttorneyData();
    getBenificiarydata();
    getOwnerdata();
  }, []);

  const [selectPieChart, setSelectPieChart] = useState(false);
  const [selectAreaChart, setSelectAresChart] = useState(true);
  const toggleSelectChart = (value) => {
    if (value === "pie") {
      setSelectPieChart(true);
      setSelectAresChart(false);
    } else {
      setSelectPieChart(false);
      setSelectAresChart(true);
    }
  };

  const [currDateTime, setCurrDateTime] = useState({
    date: new Date()
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-"),
    time: new Date().toLocaleTimeString(),
  });

  const [greeting, setGreeting] = useState("Good Morning");
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const hours = now.getHours();

      // Determine the appropriate greeting based on the current hour
      if (hours < 12) {
        setGreeting("Good Morning");
      } else if (hours < 18) {
        setGreeting("Good Afternoon");
      } else {
        setGreeting("Good Evening");
      }

      // Update date and time
      setCurrDateTime({
        date: now
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .replace(/ /g, "-"),
        time: now.toLocaleTimeString(),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const [networthData, setNetworthData] = useState(null);
  const [liabilitiesValue, setLiabilitiesValue] = useState(null);
const [realEstateMortgage, setRealEstateMortgage] = useState(0);
const [vehicleMortgage, setVehicleMortgage] = useState(0);
const [internationalMortgage, setInternationalMortgage] = useState(0);

  const formatShortAmount = (amount) => {
    const value = Number(amount);

    if (!value) return "$0";

    if (value >= 1_000_000_000_000)
      return `$${(value / 1_000_000_000_000).toFixed(1)}T`;

    if (value >= 1_000_000_000)
      return `$${(value / 1_000_000_000).toFixed(1)}B`;

    if (value >= 1_000_000)
      return `$${(value / 1_000_000).toFixed(1)}M`;

    if (value >= 1000)
      return `$${(value / 1000).toFixed(1)}K`;

    return formatAmount(value);
  };

const data = [
  {
    title: "Real Estate",
    // value: formatAmount(networthData?.RealEstate),
    value: networthData?.RealEstate,
    mortgage: realEstateMortgage,
    url: "real-estate",
    image: `${process.env.PUBLIC_URL}/img/realestate.webp`,
  },
  {
    title: "Banks",
    // value: formatAmount(networthData?.Bank),
    value: networthData?.Bank,
    url: "banks",
    image: `${process.env.PUBLIC_URL}/img/bank.webp`,
  },
  {
    title: "Investment",
    // value: formatAmount(networthData?.Investment),
    value: networthData?.Investment,
    url: "investments",
    image: `${process.env.PUBLIC_URL}/img/investment.webp`,
  },
  {
    title: "Insurances",
    // value: formatAmount(networthData?.Insurance),
    value: networthData?.Insurance,
    url: "insurances",
    image: `${process.env.PUBLIC_URL}/img/insurance.webp`,
  },
  {
    title: "Vehicles (Beta)",
    // value: formatAmount(networthData?.Vehicles),
    value: networthData?.Vehicles,
    mortgage: vehicleMortgage,
    url: "vehicles",
    image: `${process.env.PUBLIC_URL}/img/vehicle1.webp`,
  },
  {
    title: "Business-Passive Income (Beta)",
    // value: formatAmount(networthData?.Income),
    value: networthData?.Income,
    url: "income",
    image: `${process.env.PUBLIC_URL}/img/income.webp`,
  },
  {
    title: "Crypto",
    // value: formatAmount(networthData?.Crypto),
    value: networthData?.Crypto,
    url: "crypto",
    image: `${process.env.PUBLIC_URL}/img/crypto.webp`,
  },
  {
    title: "Jewelry",
    // value: formatAmount(networthData?.Jewelry),
    value: networthData?.Jewelry,
    url: "jewelry",
    image: `${process.env.PUBLIC_URL}/img/jewelry.webp`,
  },
  {
    title: "Miscellaneous Assets",
    // value: formatAmount(networthData?.OtherAsset),
    value: networthData?.OtherAsset,
    url: "other-assests",
    image: `${process.env.PUBLIC_URL}/img/other_assets.webp`,
  },
  {
    title: "International Assets (Beta)",
    // value: formatAmount(networthData?.InternationalAsset),
    value: networthData?.InternationalAsset,
    mortgage: internationalMortgage,
    url: "International_assets",
    image: `${process.env.PUBLIC_URL}/img/international_assests.jpg`,
  },
];


  // pie chart
  const assetData = [
    { name: "Real Estate", value: networthData?.RealEstate },
    { name: "Banks", value: networthData?.Bank },
    { name: "Investment", value: networthData?.Investment },
    { name: "Crypto", value: networthData?.Crypto },
    { name: "Jewelry", value: networthData?.Jewelry },
    { name: "Insurance", value: networthData?.Insurance },
    { name: "Vehicle", value: networthData?.Vehicles },
    { name: "Business-Passive Income", value: networthData?.Income },
    { name: "Miscellaneous Asset", value: networthData?.OtherAsset },
    { name: "International Asset", value: networthData?.InternationalAsset },
  ];

  const allAssetsValuesZero = assetData.every((item) => item.value === 0);

  const COLORS = [
    "#6A89CC", // Soft Blue
    "#78E08F", // Soft Green
    "#F8C291", // Light Peach
    "#E77F67", // Muted Coral
    "#82CCDD", // Light Teal
    "#60A3BC", // Desaturated Cyan
    "#E55039", // Warm Red
    "#F6B93B", // Warm Yellow
    "#B8E994", // Soft Lime
    "#546DE5", // Medium Indigo
  ];

  const liabilitiesData = [
    { name: "Credit Card", value: liabilitiesValue?.CreditCard },
    { name: "Mortgage/Loan", value: liabilitiesValue?.Mortgage },
    { name: "Personal Loan", value: liabilitiesValue?.PersonalLoan },
  ];

  const allLiabilitiesValuesZero = liabilitiesData.every(
    (item) => item.value === 0
  );

  const LIGHT_COLORS = ["#90ee90", "#90c6ee", "#ee9090"];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

const renderActiveShape = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, value } = props;

  return (
    <g>
      <motion.g
        initial={{ scale: 1 }}
        animate={{ scale: 1.08 }} // smooth growth
        transition={{ duration: 0.4, ease: "easeInOut" }}
        transform-origin={`${cx}px ${cy}px`}
      >
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </motion.g>
      <text
        x={cx}
        y={cy - 6}
        textAnchor="middle"
        fill="#333"
        style={{ fontWeight: 500, fontSize: '12px' }}
      >
        {payload.name}
      </text>
      <text
        x={cx}
        y={cy + 8}
        textAnchor="middle"
        fill={fill}
        style={{ fontSize: '16px', fontWeight: 600 }}
      >
        ${value.toLocaleString()}
      </text>
    </g>
  );
};



  // get networth graph data from backend
  const [networthGraph, setNetworthGraph] = useState(null);
  const getNetworthForAreaChartGraph = () => {
    const userId = getUser().commonId;
    getNetworthForGraph(userId)
      .then((res) => {
        setNetworthGraph(res);
      })
      .catch((error) => {});
  };

  // Custom tooltip formatter
  const formatTooltip = (value) => formatAmount(value);
  const [timeFilter, setTimeFilter] = useState("1month");

  const getRoundedEvenValue = (value, roundTo) => {
    const roundedValue = Math.ceil(value / roundTo);
    return roundedValue % 2 === 0
      ? roundedValue * roundTo
      : roundedValue * roundTo + roundTo;
  };
  const filterDataByTimeRange = (data, range) => {
    const now = new Date();
    let startDate;

    switch (range) {
      case "1month":
        startDate = new Date();
        startDate.setMonth(now.getMonth() - 1);
        break;
      case "6months":
        startDate = new Date();
        startDate.setMonth(now.getMonth() - 6);
        break;
      case "1year":
        startDate = new Date();
        startDate.setFullYear(now.getFullYear() - 1);
        break;
      case "5years":
        startDate = new Date();
        startDate.setFullYear(now.getFullYear() - 5);
        break;
      case "all-time":
        return data;
      default:
        return data;
    }

    // return data.filter((item) => new Date(item.date) >= startDate);

    const filteredData = data.filter(
      (item) => new Date(item.date) >= startDate
    );

    const dataMap = filteredData.reduce((acc, item) => {
      const formattedDate = new Date(item.date).toISOString().split("T")[0];
      acc[formattedDate] = item;
      return acc;
    }, {});

    const dateRangeData = [];
    let latestNetWorth = 0;
    startDate.setDate(startDate.getDate() + 1);
    for (
      let date = new Date(startDate + 1);
      date <= now;
      date.setDate(date.getDate() + 1)
    ) {
      const formattedDate = date.toISOString().split("T")[0];
      if (dataMap[formattedDate]) {
        latestNetWorth = dataMap[formattedDate].netWorthValue;
        dateRangeData.push(dataMap[formattedDate]);
      } else {
        // Use the latest net worth value instead of defaulting to 0
        dateRangeData.push({
          date: formattedDate,
          netWorthValue: latestNetWorth,
        });
      }
    }

    return dateRangeData;
  };

  const handleTimeFilterChange = (range) => {
    setTimeFilter(range);
  };

  const filteredData = useMemo(() =>
      networthGraph ? filterDataByTimeRange(networthGraph, timeFilter) : [],
      [networthGraph, timeFilter]
    );

    const { roundedMaxValue, roundedMinValue } = useMemo(() => {
        let max = 0;
        let min = 0;

        if (filteredData.length > 0) {
          max = filteredData.reduce((maxVal, item) =>
              Math.max(maxVal, item.netWorthValue || 0),
              0
          );
          min = filteredData.reduce((minVal, item) =>
              Math.min(minVal, item.netWorthValue || 0),
              0
          );
        }

        const roundedMax = max > 0
            ? getRoundedEvenValue(max, 1000)
            : 1000;

        const roundedMinRaw = min < 0
            ? getRoundedEvenValue(Math.abs(min), 1000)
            : 0;
        return {
            roundedMaxValue: roundedMax,
            roundedMinValue: -roundedMinRaw
        };

      }, [filteredData, getRoundedEvenValue]);

    const [brushIndexRange, setBrushIndexRange] = useState({ startIndex: 0, endIndex: 0 });

    useEffect(() => {
      if (filteredData.length > 0) {
        setBrushIndexRange({ startIndex: 0, endIndex: filteredData.length - 1 });
      } else {
        setBrushIndexRange({ startIndex: 0, endIndex: 0 });
      }
    }, [filteredData.length]);

    const onBrushChange = (range) => {
      if (range) {
          setBrushIndexRange(range);
      }
    };



  // Function to format tick
  const tickFormatter = (dateString, filter) => {
    const date = parseISO(dateString);
    const now = new Date();
    const diffMonths = differenceInMonths(now, date);
    const diffYears = differenceInYears(now, date);

    switch (filter) {
      case "1month":
        // Show date every 7 days
        if (date.getDate() % 7 === 0) {
          return format(date, "MMM d");
        }
        return "";
      case "6months":
         // Show only month name
        if (diffMonths <= 6) {
          return format(date, "MMM yyyy");
        }
        return "";
      case "1year":
        // Show month name for the past year
        if (diffYears <= 1) {
          return format(date, "MMM yyyy");
        }
        return "";
      case "5years":
      case "all-time":
        // Show year for the past 5 years or all time
        if (diffYears <= 5) {
          return format(date, "yyyy");
        }
        return "";
      default:
        return "";
    }
  };

  const handleInviteAttorneyClick = () => {
  const token = "Bearer " + getToken();
  const username = getUser().username;
  const userEmail = getUser().email;

  // fetch invitations + attorneys
Promise.all([
  getExistAttorneyInvitationByUsername(token, username),
  getAllAcceptedAttorneysByUsername(token, userEmail),
])
  .then(([invitations, attorneys]) => {
    const invitationCount = invitations ? invitations.length : 0;
    const attorneyCount = attorneys ? attorneys.length : 0;

    if (invitationCount + attorneyCount >= 2) {
      toast.error("You can't add more than 2 attorneys/agents", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    toggleAttorney();
  })
  .catch(() => {
    toast.error("Error checking attorney limit", {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  });

  };

  // Determine interval based on the filter
  const getInterval = () => {
    switch (timeFilter) {
      case "1month":
        return 0;
      case "6months":
      case "1year":
        return 30;
      case "5years":
        return 420;
      case "all-time":
        return 60;
      default:
        return 0;
    }
  };

  useEffect(() => {
    getNetworthForAreaChartGraph();
  }, []);

  // networth api start
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

useEffect(() => {
  const fetchData = async () => {
    try {
      const rawToken = await getToken();
      const token = `Bearer ${rawToken}`;

      const [
        networth,
        realEstateData,
        vehicleData,
        internationalAssets,
      ] = await Promise.all([
        getNetworth(userId),
        getRealEstates(token, userId),
        getVehicle(token, userId),
        getInternationalAsset(token, userId),
      ]);

      // const networth = await getNetworth(userId);
      setNetworthData(networth);

      // const realEstateData = await getRealEstates(token, userId);
      const realEstateMortgageTotal = realEstateData.reduce(
        (sum, item) => sum + parseFloat(item.realEstate?.mortgage || 0),
        0
      );
      setRealEstateMortgage(realEstateMortgageTotal);

      // const vehicleData = await getVehicle(token, userId);
      const vehicleMortgageTotal = vehicleData.reduce(
        (sum, item) => sum + parseFloat(item.mortgage?.mortgage || 0),
        0
      );
      setVehicleMortgage(vehicleMortgageTotal);

    // const internationalAssets = await getInternationalAsset(token, userId);

    const internationalMortgageTotal = internationalAssets.reduce((sum, item) => {
      const mortgageAmount =
        parseFloat(item.assetData?.mortgage?.mortgage || 0) ||
        parseFloat(item.assetData?.mortgages?.[0]?.mortgage || 0);
      return sum + mortgageAmount;
    }, 0);

    setInternationalMortgage(internationalMortgageTotal);
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchLiabilitiesValue = async () => {
    try {
      const data = await getLiabilitiesValue(userId);
      setLiabilitiesValue(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
  fetchLiabilitiesValue();
}, [userId]);


  // if (loading) return <p>Loading...</p>;
  if (loading) {
    return <Loading show={true} />;
  }
  if (error) return <p>Error: {error.message}</p>;

  // networth api end
  return (
    <>
      {showPopup && (
        <Suspense fallback={<Loading show={loading} />}>
          <GenerateWill combinedData={combinedData} closePopup={closePopup} />
        </Suspense>
      )}

      {!showPopup && (
        <div className={`your-component ${show ? "fade-in-element" : ""}`}>
          <UserBase>
            <div style={{ marginTop: "4rem" }} className="otherElement">
              <SideBar>
                <div
                  style={{
                    backgroundColor: "yellow",
                    padding: "3px 0 6px 0",
                  }}
                >
                  <Suspense fallback={<div>Loading...</div>}>
                    <Notification />
                  </Suspense>
                </div>

                {addBeneficiary && (
                  <div
                    className="beneficiary-popup"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-delay="50"
                    data-aos-duration="1000"
                  >
                    <div className="beneficiary-content">
                      {addBeneficiary && (
                        <Suspense fallback={<div>Loading...</div>}>
                          <BeneficiarySignup handleBack={handleBack} />
                        </Suspense>
                      )}
                    </div>
                  </div>
                )}

                {addJointPopup && (
                  <div
                    className="beneficiary-popup"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-delay="50"
                    data-aos-duration="1000"
                  >
                    <div className="beneficiary-content">
                      {addJointPopup && (
                        // <Suspense fallback={<div>Loading...</div>}>
                          <Suspense fallback={<Loading show={null} />}>
                          <JointAccount userId={userId} onBack={handleBack} />
                        </Suspense>
                      )}
                    </div>
                  </div>
                )}

                {addOwner && (
                  <div
                    className="beneficiary-popup"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-delay="50"
                    data-aos-duration="1000"
                  >
                    <div className="beneficiary-content">
                      {addOwner && <CreateOwner onBack={handleBack} />}
                    </div>
                  </div>
                )}

                {addTrust && (
                  <div
                    className="beneficiary-popup"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-delay="50"
                    data-aos-duration="1000"
                  >
                    <div className="beneficiary-content">
                      {addTrust && <CreateTrust onBack={handleBack} />}
                    </div>
                  </div>
                )}

                {attorneyPopup && (
                  <div
                    className="beneficiary-popup"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-delay="50"
                    data-aos-duration="1000"
                  >
                    <div className="beneficiary-content">
                      {attorneyPopup && (
                        <AttorneyDetail handleBack={handleBack} />
                      )}
                    </div>
                  </div>
                )}

                <div style={{ textAlign: "center" }} className="main">
                  <div className="Dashboard_main">
                    <div className="dashboard_left">
                      <div className="user_details_dash">
                        <div className="UserDetails">
                          <p className="Username_details">
                            {greeting},{" " + user.firstName}
                            <br />
                            Welcome to I
                            {/*<span style={{ color: "#059212" }}>-</span>Chest.com*/}
                            <span style={{ color: "#000000" }}>-</span>Chest.com
                          </p>
                          <p className="date_time_details">
                            Today {currDateTime.date} {currDateTime.time}
                          </p>
                        </div>
                        <div className="User_action_btns ">
                          <div className="user_dashbord_btn">
                            {beneficiary ? (
                              <div
                                className="dashboard_action_btn"
                                onClick={toggleBeneficiary}
                              >
                                Add Beneficiaries
                              </div>
                            ) : (
                              <div
                                className="dashboard_action_btn"
                                onClick={toggleBeneficiary}
                              >
                                Add Beneficiary
                              </div>
                            )}

                            <div
                              className="dashboard_action_btn"
                              onClick={toggleJointAccount}
                            >
                              Invite Secondary Account
                            </div>
                          </div>
                          <div className="user_dashbord_btn">
                            <div
                              className="dashboard_action_btn"
                              onClick={getCombinedDataFromServer}
                            >
                              Inventory Report
                            </div>
                            {/* {attorneyStringType && ( */}
                            <div
                              className="dashboard_action_btn"
                              onClick={handleInviteAttorneyClick}
                            >
                              Invite Attorneys/Agents
                            </div>
                            {/* )} */}
                          </div>
                          <div className="user_dashbord_btn">
                            {isOwner ? (
                              <div
                                className="dashboard_action_btn"
                                onClick={toggleAddOwner}
                              >
                                Add Owners
                              </div>
                            ) : (
                              <div
                                className="dashboard_action_btn"
                                onClick={toggleAddOwner}
                              >
                                Add Owner
                              </div>
                            )}
                            {isOwner ? (
                              <div
                                className="dashboard_action_btn"
                                onClick={toggleAddTrust}
                              >
                                Add Trusts
                              </div>
                            ) : (
                              <div
                                className="dashboard_action_btn"
                                onClick={toggleAddTrust}
                              >
                                Add Trust
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="user_chart_dash_main">
                        <div className="chart_button">
                          <button
                            className={`chart_all_button ${
                              selectAreaChart ? "selected" : ""
                            }`}
                            onClick={() => toggleSelectChart("area")}
                          >
                            Total Net Worth
                          </button>
                          <button
                            className={`chart_all_button ${
                              selectPieChart ? "selected" : ""
                            }`}
                            onClick={() => toggleSelectChart("pie")}
                          >
                            Assets/Liabilities Value
                          </button>
                        </div>
                        <div className="user_charts">
                          {selectAreaChart ? (
                            <div className="user_chart_dash">
                              <div className="chat_filter_buttons">
                                <div className="Totalnetworth">
                                  <p>
                                    Approx Net Worth:{" "}
                                    <span className="networth_amount">
                                      {formatAmount(
                                        networthData?.AdjustedNetWorth
                                      )}
                                    </span>
                                  </p>
                                </div>
                                <div>
                                  <button
                                    className="filter_button_style"
                                    onClick={() =>
                                      handleTimeFilterChange("1month")
                                    }
                                    style={{
                                      color:
                                        timeFilter === "1month"
                                          ? "blue"
                                          : "black",
                                    }}
                                  >
                                    1 Month
                                  </button>
                                  <button
                                    className="filter_button_style"
                                    onClick={() =>
                                      handleTimeFilterChange("6months")
                                    }
                                    style={{
                                      color:
                                        timeFilter === "6months"
                                          ? "blue"
                                          : "black",
                                    }}
                                  >
                                    6 Months
                                  </button>
                                  <button
                                    className="filter_button_style"
                                    onClick={() =>
                                      handleTimeFilterChange("1year")
                                    }
                                    style={{
                                      color:
                                        timeFilter === "1year"
                                          ? "blue"
                                          : "black",
                                    }}
                                  >
                                    1 Year
                                  </button>
                                  <button
                                    className="filter_button_style"
                                    onClick={() =>
                                      handleTimeFilterChange("5years")
                                    }
                                    style={{
                                      color:
                                        timeFilter === "5years"
                                          ? "blue"
                                          : "black",
                                    }}
                                  >
                                    5 Years
                                  </button>
                                  <button
                                    className="filter_button_style"
                                    onClick={() =>
                                      handleTimeFilterChange("all-time")
                                    }
                                    style={{
                                      color:
                                        timeFilter === "all-time"
                                          ? "blue"
                                          : "black",
                                    }}
                                  >
                                    All Time
                                  </button>
                                </div>
                              </div>
                                  <div className="user_areachart" style={{ width: "100%", height: 350 }}>
                                        <ResponsiveContainer width="100%" height="100%">
                                          <AreaChart
                                            data={filteredData}
                                            margin={{ top: 10, right: 30, left: 30, bottom: 0 }}
                                          >
                                            <defs>
                                              <linearGradient id="colorNetworth" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#7286D3" stopOpacity={0.8} />
                                                <stop offset="95%" stopColor="#7286D3" stopOpacity={0} />
                                              </linearGradient>
                                            </defs>

                                            <XAxis
                                              dataKey="date"
                                              type="category"
                                              axisLine={false}
                                              tickLine={false}
                                              interval="preserveStartEnd"
                                              minTickGap={48}
                                              tickFormatter={(tick) => tickFormatter(tick, timeFilter)}
                                              tick={{ fontSize: 14, fill: "#2C74B3" }}
                                              height={36}
                                            />

                                            <YAxis
                                              domain={[roundedMinValue, roundedMaxValue]}
                                              axisLine={false}
                                              tickLine={false}
                                              tickCount={6}
                                              tick={{ fontSize: 14, fill: "#2C74B3" }}
                                              ticks={[
                                                        roundedMinValue,
                                                        0,
                                                        roundedMaxValue / 4,
                                                        roundedMaxValue / 2,
                                                        (roundedMaxValue * 3) / 4,
                                                        roundedMaxValue,
                                              ]}
                                              tickFormatter={formatAmount}
                                              width={80}
                                            />

                                            <Tooltip
                                              contentStyle={{
                                                borderRadius: 8,
                                                border: "none",
                                                boxShadow: "0 6px 24px #aaa",
                                                fontSize: 15,
                                              }}
                                              labelStyle={{ fontWeight: "bold", color: "#404040" }}
                                              cursor={{ fill: "rgba(44,116,179,0.08)" }}
                                              formatter={(value) => [`Networth: ${formatAmount(value)}`]}
                                              labelFormatter={(label) =>
                                                format(parseISO(label), "eeee, d MMM, yyyy")
                                              }
                                            />

                                            <Area
                                              type="monotone"
                                              dataKey="netWorthValue"
                                              stroke="#2C74B3"
                                              strokeWidth={2}
                                              fillOpacity={1}
                                              fill="url(#colorNetworth)"
                                              baseLine={0}
                                              dot={false}
                                              activeDot={{ r: 5, stroke: "#2C74B3", fill: "#fff", strokeWidth: 2 }}
                                            />

                                            <Brush
                                              dataKey="date"
                                              height={28}
                                              stroke="#2C74B3"
                                              travellerWidth={5}
                                              tickFormatter={(tick) => tickFormatter(tick, timeFilter)}
                                              startIndex={brushIndexRange.startIndex}
                                              endIndex={brushIndexRange.endIndex}
                                              onChange={onBrushChange}
                                            />
                                          </AreaChart>
                                        </ResponsiveContainer>
                                      </div>
                            </div>
                          ) : (
                            <div className="user_pie_chart_main" style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                              <motion.div
                                initial={{ opacity: 0, x: -50, scale: 0.95 }}
                                animate={{ opacity: 1, x: 0, scale: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }}
                                className="user_pie_chart_with_assets"
                                style={{ flex: 1, minWidth: "300px", display: "flex", gap: "20px", alignItems: "center" }}
                              >
                                <div className="user_pie_chart" style={{ height: 300, position: "relative" }}>
                                  {allAssetsValuesZero ? (
                                    <p style={{ fontWeight: "500" }}>No data to show</p>
                                  ) : (
                                    <>
                                      <ResponsiveContainer width="100%" height="100%">
                                        <PieChart>
                                          <Pie
                                            data={assetData}
                                            cx="50%"
                                            cy="50%"
                                            labelLine={false}
                                            innerRadius={60}
                                            outerRadius={120}
                                            dataKey="value"
                                            paddingAngle={2}
                                            activeIndex={activeAssetIndex}
                                            activeShape={renderActiveShape}
                                            onMouseEnter={(_, index) => setActiveAssetIndex(index)}
                                            onMouseLeave={() => setActiveAssetIndex(null)}
                                            animationBegin={0}
                                            animationDuration={800}
                                            animationEasing="ease-in-out"
                                            startAngle={90}
                                            endAngle={450}
                                          >
                                            {assetData.map((entry, index) => (
                                              <Cell
                                                key={`cell-asset-${index}`}
                                                fill={COLORS[index % COLORS.length]}
                                                style={{
                                                  outline: 'none',
                                                  cursor: 'pointer',
                                                  transform: activeAssetIndex === index ? 'scale(1.125)' : 'scale(1)',
                                                  transformOrigin: 'center',
                                                  transition: 'transform 0.8s ease-in-out, filter 0.8s ease-in-out',
                                                  filter: activeAssetIndex === index ? 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))' : 'none',
                                                }}
                                              />
                                            ))}
                                          </Pie>
                                          <Tooltip
                                            formatter={formatTooltip}
                                            contentStyle={{
                                              backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                              border: '1px solid #ccc',
                                              borderRadius: '4px',
                                              padding: '8px'
                                            }}
                                          />
                                        </PieChart>
                                      </ResponsiveContainer>
                                      <p style={{ fontWeight: "500", textAlign: "center", marginTop: 12 }}>
                                        All Assets Value
                                      </p>
                                    </>
                                  )}
                                </div>
                                <div className="user_pie_chart_details" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                  {assetData.map(
                                    (data, index) =>
                                      data.value > 0 && (
                                        <div
                                          className="pie_chart_details"
                                          key={`asset-detail-${index}`}
                                          style={{ display: "flex", alignItems: "center", gap: 8 }}
                                        >
                                          <div
                                            className="pie_chart_detail_box"
                                            style={{
                                              width: 16,
                                              height: 16,
                                              backgroundColor: COLORS[index],
                                              borderRadius: '50%',
                                            }}
                                          ></div>
                                          <p style={{ margin: 0 }}>{data.name}</p>
                                        </div>
                                      )
                                  )}
                                </div>
                              </motion.div>

                              <motion.div
                                initial={{ opacity: 0, x: 50, scale: 0.95 }}
                                animate={{ opacity: 1, x: 0, scale: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                                className="user_pie_chart_with_liabilities"
                                style={{ flex: 1, minWidth: "300px", display: "flex", gap: "20px", alignItems: "center" }}
                              >
                                <div className="user_pie_chart" style={{ height: 300, position: "relative" }}>
                                  {allLiabilitiesValuesZero ? (
                                    <p style={{ fontWeight: "500" }}>No data to show</p>
                                  ) : (
                                    <>
                                      <ResponsiveContainer width="100%" height="100%">
                                        <PieChart>
                                          <Pie
                                            data={liabilitiesData}
                                            cx="50%"
                                            cy="50%"
                                            labelLine={false}
                                            innerRadius={60}
                                            outerRadius={120}
                                            dataKey="value"
                                            paddingAngle={2}
                                            activeIndex={activeLiabilityIndex}
                                            activeShape={renderActiveShape}
                                            onMouseEnter={(_, index) => setActiveLiabilityIndex(index)}
                                            onMouseLeave={() => setActiveLiabilityIndex(null)}
                                            animationBegin={0}
                                            animationDuration={800}
                                            animationEasing="ease-in-out"
                                            startAngle={90}
                                            endAngle={450}
                                          >
                                            {liabilitiesData.map((entry, index) => (
                                              <Cell
                                                key={`cell-liability-${index}`}
                                                fill={LIGHT_COLORS[index % LIGHT_COLORS.length]}
                                                style={{
                                                  outline: 'none',
                                                  cursor: 'pointer',
                                                  transform: activeLiabilityIndex === index ? 'scale(1.125)' : 'scale(1)',
                                                  transformOrigin: 'center',
                                                  transition: 'transform 0.8s ease-in-out, filter 0.8s ease-in-out',
                                                  filter: activeLiabilityIndex === index ? 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))' : 'none',
                                                }}
                                              />
                                            ))}
                                          </Pie>
                                          <Tooltip
                                            formatter={formatTooltip}
                                            contentStyle={{
                                              backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                              border: '1px solid #ccc',
                                              borderRadius: '4px',
                                              padding: '8px'
                                            }}
                                          />
                                        </PieChart>
                                      </ResponsiveContainer>
                                      <p style={{ fontWeight: "500", textAlign: "center", marginTop: 12 }}>
                                        All Liabilities Value
                                      </p>
                                    </>
                                  )}
                                </div>
                                <div className="user_pie_chart_details" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                  {liabilitiesData.map(
                                    (data, index) =>
                                      data.value > 0 && (
                                        <div
                                          className="pie_chart_details"
                                          key={`liability-detail-${index}`}
                                          style={{ display: "flex", alignItems: "center", gap: 8 }}
                                        >
                                          <div
                                            className="pie_chart_detail_box"
                                            style={{
                                              width: 16,
                                              height: 16,
                                              backgroundColor: LIGHT_COLORS[index],
                                              borderRadius: '50%',
                                            }}
                                          ></div>
                                          <p style={{ margin: 0 }}>{data.name}</p>
                                        </div>
                                      )
                                  )}
                                </div>
                              </motion.div>
                            </div>

                          )}
                        </div>
                      </div>
                    </div>
                    <div className="dashboard_right">
                      <div className="Assets_count">
                     <div className="flex items-center justify-between mb-3">
                      {/* Left side text */}
                      <p className="Assets_report_heading">Add and View Assets  &nbsp;&nbsp;
                      {/* Right side switch */}
                      <FormControlLabel
                        control={
                          <Switch
                            checked={showValues}
                            onChange={() => setShowValues(!showValues)}
                            color="primary"
                          />
                        }
                        label={showValues ? "Hide" : "Show"}
                        labelPlacement="end"
                      />
                      </p>
                    </div>
                        <div className="all_assets_report">
                          {[...data]
                            .sort((a, b) => {
                              if (a.title.includes("International") && !b.title.includes("International")) {
                                return 1;
                              }
                              if (!a.title.includes("International") && b.title.includes("International")) {
                                return -1;
                              }

                              // const valueA = parseFloat(a.value.toString().replace(/[^0-9.-]+/g, "")) || 0;
                              // const valueB = parseFloat(b.value.toString().replace(/[^0-9.-]+/g, "")) || 0;
                              const valueA = Number(a.value) || 0;
                              const valueB = Number(b.value) || 0;
                              return valueB - valueA;
                            })
                            .map((item, index) => (
                              <div
                                key={index}
                                className="assets_card"
                                onClick={() => handleClick(item.url)}
                              >
                                <img
                                  className="assets_image"
                                  src={item.image}
                                  alt={item.title}
                                />
                                <div className="assets_data">
                                  <p
                                      style={{
                                        margin: 0,
                                        flex: 1,
                                        paddingRight: "12px",
                                        textAlign: "left",
                                        lineHeight: "20px",
                                      }}
                                  >{item.title}</p>
                                  {/*<p>*/}
                                  <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                  >
                                    {/* Conditionally show values */}
                                    {/*{showValues ? item.value : "•••••"}*/}
                                    <div style={{ marginLeft: "auto", textAlign: "right" }}>

                                      {showValues ? (
                                          <span className="asset-short-amount">
                                           {formatShortAmount(item.value)}
                                          </span>
                                      ) : (
                                          "•••••"
                                      )}

                                      {showValues && (
                                          <IconButton
                                              size="small"
                                              // onClick={(e) => {
                                              onMouseEnter={(e) => {
                                                e.stopPropagation();
                                                setSelectedAsset(item);
                                                setAnchorEl(e.currentTarget);
                                                setInfoOpen(true);
                                              }}
                                          >
                                            <InfoOutlinedIcon fontSize="small" />
                                          </IconButton>
                                      )}

                                      <br />

                                      {showValues &&
                                          item.mortgage !== undefined &&
                                          item.mortgage !== 0 && (
                                              <span
                                                  style={{
                                                    color: "red",
                                                    fontSize: "0.85em",
                                                  }}
                                              >
                                              {item.title === "Real Estate"
                                               ? `Mortgage: ${formatAmount(item.mortgage)}`
                                                : item.title === "Vehicles (Beta)"
                                                ? `Loan: ${formatAmount(item.mortgage)}`
                                               : item.title.includes("International")
                                             ? `Mortgage/Loan: ${formatAmount(item.mortgage)}`
                                              : null}
                                              </span>
                                          )}
                                    </div>
                                  {/*</p>*/}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {!beneficiary && attorneyStringType && (
                  <div>
                    <AlertPopup
                      userAccountType={userAccountType}
                      attorneyStringType={attorneyStringType}
                      beneficiary={beneficiary}
                      toggleBeneficiary={toggleBeneficiary}
                      toggleAttorney={toggleAttorney}
                    />
                  </div>
                )}
              </SideBar>
            </div>
            <Popover
                open={infoOpen}
                anchorEl={anchorEl}
                onClose={() => setInfoOpen(false)}
                disableRestoreFocus
                PaperProps={{
                  onMouseEnter: () => setInfoOpen(true),
                  onMouseLeave: () => {
                    setAnchorEl(null);
                    setInfoOpen(false);
                  },
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
            >
              <div style={{ padding: 15, width: 220 }}>
                <Typography variant="h6">
                  {selectedAsset?.title}
                </Typography>

                <Typography
                    style={{
                      fontWeight: "bold",
                      fontSize: "22px",
                      margin: "10px 0",
                    }}
                >
                  {formatAmount(selectedAsset?.value)}
                </Typography>
              </div>
            </Popover>
          </UserBase>
        </div>
      )}
    </>
  );
}

const formatAreaChartTooltip = (value, name, props) => {
  const { payload } = props; // Get the payload containing date (label)
  const date = payload.name; // The `name` field in your data holds the date string
  const formattedDate = format(parseISO(date), "eeee, d MMM, yyyy");

  // Return formatted value and label
  return [formattedDate];
};